/*
 * Copyright (c) Kalaora 2022.
 * Author: fharold
 *
 * hilo-oauth-manager
 * ProfileAdapter.tsx
 */

import ListAdapter, {AdapterListener} from "../../tools/list/ListAdapter";
import Profile from "../../models/Profile";
import React from "react";
import {Column} from "../../tools/list/Column"
import Translation from "../../services/translation/Translation";
import ProfileDataProvider from "../../provider/ProfileDataProvider";
import {ProfileAPIPagination} from "../../pagination/ProfileAPIPagination";

export interface ProfileAdapterListener extends AdapterListener<Profile> {
}

export default class ProfileAdapter extends ListAdapter<Profile, ProfileAdapterListener, ProfileAPIPagination> {
    private _t: Translation;

    /**
     * constructor
     * @param profilesProvider
     * @param listener
     * @param t
     */
    constructor(t: Translation, profilesProvider: ProfileDataProvider, listener?: ProfileAdapterListener) {
        super();

        this._t = t;
        this.addColumn(new Column(t.profileListColName, "name", this._name));

        this.init(
            t.profileListEmpty,
            profilesProvider,
            [],
            listener
        );
    }

    /**
     * _title
     * @returns {any}
     * @private
     * @param profile
     */
    private _name = (profile: Profile): JSX.Element => {
        return <p className={"blue-hover"}>{profile.name}</p>
    };
}